import { IAccountStatus, IRawAccountStatus } from 'models/account.model'

export const getAccountStatusFromRawStatus = (
  rawAccountStatus: IRawAccountStatus,
): IAccountStatus => ({
  existingUuid: rawAccountStatus.uuid,
  hasAccount: rawAccountStatus.has_account,
  hasAccessToApp: rawAccountStatus.access_to_app,
})
